/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import IconButton from '../../../../molecules/button/IconButton';

export const ColumnExpandIndicator = (props: {
  expandingId?: string;
  question: { utrv?: { _id: string } };
  handleGoToQuestion: () => void;
}) => {
  const { expandingId, question, handleGoToQuestion } = props;
  const isShowing = expandingId === question.utrv?._id;
  const iconClassName = isShowing ? 'fa-chevron-up' : 'fa-chevron-down';

  return (
    <Column className='text-center'>
      <IconButton
        icon={iconClassName}
        color='transparent'
        size='xs'
        outline={false}
        disabled={false}
        onClick={handleGoToQuestion}
      />
    </Column>
  );
};
